<template>
  <div class="related">
    <Loading/>
    <div data-simplebar data-simplebar-auto-hide="false" style="height: 100%;">
      <transition-group name="fade" tag="ul" class="products" >
      <li v-for="product in getComplementary" class="product" :key="product.id" @click.stop="selectProduct(product)">
          <div class="top-bar">
            <div class="checkbox" :class="{ 'selected' : selectedProduct && selectedProduct.id === product.id }">
              <label>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.70711 9.2929C3.31658 8.90238 2.68342 8.90238 2.29289 9.2929C1.90237 9.68343 1.90237 10.3166 2.29289 10.7071L7.29289 15.7071C7.69802 16.1122 8.36002 16.0948 8.74329 15.669L17.7433 5.66897C18.1128 5.25846 18.0795 4.62617 17.669 4.25671C17.2585 3.88726 16.6262 3.92053 16.2567 4.33104L7.96181 13.5476L3.70711 9.2929Z"
                        fill="#3C3C3C"/>
                </svg>
              </label>
            </div>
          </div>
          <div class="image">
            <img :src="product.image"/>
          </div>
          <div class="details">
            <p class="name">
              <span>{{ product.name }}</span>
              <button class="btn-info" @click.stop="openProductPreview(product)">
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.5 0C9.81371 0 12.5 2.68629 12.5 6C12.5 9.31371 9.81371 12 6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0ZM6.5 5C5.98716 5 5.56449 5.38604 5.50673 5.88338L5.5 6V9C5.5 9.55229 5.94772 10 6.5 10C7.01284 10 7.43551 9.61396 7.49327 9.11662L7.5 9V6C7.5 5.44772 7.05228 5 6.5 5ZM5.5 2L7.5 2V4L5.5 4V2Z"
                        fill="#3C3C3C"/>
                </svg>
              </button>
            </p>
            <p class="description">{{ product.description }}</p>
            <p class="price">{{ product.price | price }}</p>
          </div>
      </li>
    </transition-group>
    </div>
    <transition name="slide">
      <ProductComplementaryPreview v-if="productPreview" :product="productToPreview" @close="closeProductPreview"/>
    </transition>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from "vuex";
import Loading from './misc/Loading';

import ProductComplementaryPreview from './ProductComplementaryPreview'

export default {
  name: "ProductRelatedBed",
  components: {Loading, ProductComplementaryPreview},
  filters: {
    price(price) {
      if (!price) {
        return 'b.d'
      }
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    }
  },
  data() {
    return {
      selectedProduct: null,
      productPreview: false,
      productToPreview: null
    }
  },
  computed: {
    ...mapGetters({
      getOptions: 'customizer/getOptions',
      getComplementary: 'customizer/getComplementary'
    }),
    getStep() {
      return this.$parent.getStep
    },
    getSteps() {
      return this.$parent.getSteps
    }
  },
  mounted() {
    if (this.getStep) {
      this.setStep({
        ...this.getSteps.find(step => step.id === this.getStep.id),
        completed: true
      })
    }
    if (!this.getComplementary.length) {
      this.fetchProductComplementary({attribute: 'product_dimension', value: this.getOptions.pa_rozmiar_lozka})
    }
    this.selectedProduct = this.getOptions.pa_materac
  },
  methods: {
    ...mapMutations({
      setStep: 'customizer/setStep',
      setOptionMattress: 'customizer/setOptionMattress'
    }),
    ...mapActions('customizer', ['fetchProductComplementary']),
    selectProduct(item) {
      this.selectedProduct = this.selectedProduct && this.selectedProduct.id === item.id ? null : item;
      this.setOptionMattress(this.selectedProduct)
    },
    openProductPreview(product) {
      this.productPreview = true
      this.productToPreview = product
    },
    closeProductPreview() {
      this.productPreview = false
      this.productToPreview = null
    },
  }
}
</script>

<style scoped lang="scss">
.related {
  padding: 25px 0 25px 25px;
  height: 650px;
  box-sizing: border-box;
  @media (max-width: 480px) {
    padding: 25px 0;
    height: auto;
  }
  .products {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    overflow-y: auto;
    height: 100%;
    padding-right: 25px;
    @media (max-width: 480px) {
      padding-right: 0;
    }
    li {
      flex-basis: 49%;
      display: flex;
      align-items: center;
      padding: 15px;
      border: 1px solid #efefef;
      border-radius: 5px;
      margin-bottom: 11px;
      cursor: pointer;
      font-weight: 500;
      box-sizing: border-box;
      transition: all .2s;
      position: relative;
      justify-content: space-between;
      flex-direction: row;
      @media (max-width: 768px) {
        flex-basis: auto;
        margin-bottom: 15px;
      }

      @media (max-width: 480px) {
        width: 100%;
        margin-bottom: 10px;
      }

      &.selected, &:hover {
        border: 1px solid #3c3c3c;
      }

      .image {
        width: 50%;

        img {
          max-width: 100%;
          height: auto;
        }
      }

      .details {
        padding: 25px 0 10px 15px;
        width: 50%;
        @media (max-width: 768px) {
          width: 100%;
        }
          p {
            margin: 20px 0 0 0;
            color: #3c3c3c;
            &.name {
              font-weight: 600;
              display: flex;
              padding-bottom: 0;
              font-size: 14px;
              line-height: 20px;

              span {
                flex: 0 0 calc(100% - 35px);
                @media (min-width: 680px) and (max-width: 768px) {
                  flex: 0 0 calc(100% - 40px);
                }
                @media (max-width: 375px) {
                  flex: 0 0 calc(100% - 40px);
                }
              }

              .btn-info {
                margin-left: auto;
                width: 32px;
                height: 32px;
                display: inline-flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #efefef;
                border-radius: 4px;
                transition: all .2s;
                cursor: pointer;
                background: #fff;
                padding: 0;

                &:hover {
                  background: #f5f5f5;
                }

                svg {
                  width: 13px;
                  height: 12px;
                  display: inline-block;
                }
              }

            }

            &.description {
              padding-bottom: 15px;
              font-size: 12px;
              line-height: 16px;
              letter-spacing: 0.4px;
              color: #969696;

              &:after {
                content: '';
                width: 50px;
                height: 1px;
                background: #EFEFEF;
                display: block;
                margin-top: 20px;
              }
            }

            &.price {
              font-weight: 600;
              font-size: 16px;
              line-height: 18px;
              color: #3C3C3C;
            }

            &:last-child {
              margin: 0;
            }
          }
      }

      .top-bar {
        position: absolute;
        top: 15px;
        right: 15px;
        display: flex;

        .quantity-input {
          display: flex;
          flex: 0 0 80px;
          height: 30px;
          margin-right: 15px;

          button {
            background-color: #fff;
            border: 1px solid #E6E6E6;
            box-shadow: none;
            display: inline-flex;
            align-items: center;
            cursor: pointer;
            transition: all .2s;

            &:hover {
              background-color: #f9f9f9;
            }

            &:first-child {
              border-radius: 4px 0px 0px 4px;
              border-right: none;
            }

            &:last-child {
              border-radius: 0px 4px 4px 0px;
              border-left: none;
            }
          }

          .input-value {
            border: 1px solid #efefef;
            padding: 0 15px;
            display: inline-flex;
            align-items: center;
            font-weight: 600;
            color: #3c3c3c;
          }
        }

        .checkbox {
          label {
            width: 30px;
            height: 30px;
            border: 1px solid #efefef;
            border-radius: 4px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            transition: all .2s;

            svg {
              opacity: 0;
            }

          }

          &.selected label svg {
            opacity: 1;
          }
        }
      }

    }
  }
}

.slide-leave-active,
.slide-enter-active,
.slide-leave-to {
  transition: transform .3s, opacity .3s;
}

.slide-enter {
  transform: translate(100%, 0);
  position: absolute;
  @media (max-width: 480px) {
    position: fixed;
  }
}

.slide-leave-to {
  transform: translate(100%, 0);
  position: absolute;
  @media (max-width: 480px) {
    position: fixed;
  }
}
</style>
